<template>
  <span v-if="currentEnvironment"> {{ currentEnvironment }} </span>
</template>

<script setup lang="ts">

import useEnvCheck from "@/composables/useEnvCheck";
import { computed } from "vue";

const { envCheck } = useEnvCheck();

const props = defineProps<{
  environment?: "LOCAL" | "DEV" | "QA" | "STAGE" | "";
}>();

const currentEnvironment = computed(() => {
  if (props.environment) {
    return props.environment;
  }

  return envCheck();
});
</script>

<style scoped lang="scss">
span {
  position: fixed;
  top: 20px;
  left: -40px;
  background: rgba(220, 25, 25, 0.9);
  color: white;
  padding: 0.35em;
  z-index: 999;
  transform: rotate(-45deg);
  width: 150px;
  text-align: center;
  font-weight: bold;
  box-shadow: 0px 2px var(--c-blue);
}
</style>
